module.exports = __webpack_public_path__ + "img/national_emblem.ae5b3ab3.png";